import { render, staticRenderFns } from "./UserRequestList.vue?vue&type=template&id=60576411&"
import script from "./UserRequestList.vue?vue&type=script&lang=js&"
export * from "./UserRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports